// import { MarketActivityIndicator } from '@market/react';
// import { useHistory } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   RequestContext,
//   customerSelector,
//   customerContextSelector,
//   getCustomer,
//   getCustomerStateSelector,
// } from 'store/customer';
// import ConnectionError from 'screens/ConnectionError';
// import {
//   fetchDiscounts,
//   fetchDiscountsStateSelector,
//   updatedDiscountsSelector,
// } from 'store/discounts';
//
// const CHECKING_OUT_QUERY_PARAM = '?checking_out=true';

import { useEffect } from 'react';
import { view } from '@squareup/sq-addons-web-sdk';

const CheckingRewardsScreen = () => {
  // let history = useHistory();
  // const dispatch = useDispatch();

  // const customer = useSelector(customerSelector);
  // const customerContext = useSelector(customerContextSelector);
  // const updatedDiscounts = useSelector(updatedDiscountsSelector);
  // const fetchDiscountsState = useSelector(fetchDiscountsStateSelector);
  // const getCustomerState = useSelector(getCustomerStateSelector);

  // useEffect(() => {
  //   dispatch(getCustomer(RequestContext.SDK));
  // }, [dispatch]);

  // useEffect(() => {
  //   if (customer && customerContext === RequestContext.SDK) {
  //     dispatch(fetchDiscounts());
  //   }
  // }, [dispatch, customer, customerContext]);

  // useEffect(() => {
  //   // If we successfully fetched the customer's discounts, redirect to the
  //   // invalid discounts page if there are discounts that needs to be removed
  //   // or to the customer page.
  //   if (fetchDiscountsState.success) {
  //     updatedDiscounts.length > 0
  //       ? history.push('/invalid-discounts' + CHECKING_OUT_QUERY_PARAM)
  //       : history.push('/customer' + CHECKING_OUT_QUERY_PARAM);
  //     return;
  //   }
  //
  //   // If the get customer request did not originate from this context, or it is still
  //   // pending, do nothing
  //   if (customerContext !== RequestContext.SDK || getCustomerState.isPending) {
  //     return;
  //   }
  //
  //   // This means there is no customer on the order, so we should redirect to the Main screen
  //   if (!customer?.referenceId) {
  //     history.push('/' + CHECKING_OUT_QUERY_PARAM);
  //   }
  // }, [
  //   customer,
  //   customerContext,
  //   updatedDiscounts.length,
  //   getCustomerState.isPending,
  //   history,
  //   fetchDiscountsState.success,
  // ]);

  useEffect(() => {
    view.continueClicked();
  });

  return (
    <div
      className="market-grid-container"
      data-testid="checking-rewards-container"
    >
      {/*<div
        className="addons-checking-rewards-loading-indicator market-grid-item-full"
        data-testid="checking-rewards-component"
      >
        <MarketActivityIndicator data-testid="loading-indicator" size="small" />
        <h3>Checking rewards</h3>
        <p>Just a moment while we double check the rewards.</p>
      </div>*/}
    </div>
  );
};

export default CheckingRewardsScreen;
